// import { UsuarioService } from '../../core/services/core/usuario.service';
// import { EmpresaService } from '../../core/services/organizacion/empresa.service';
import { MenuItems, MenuItem } from '../../core/menu/MenuItem';
import { AuthService } from '../../core/services/acceso/auth.service';
import { SessionHelper } from '../../core/helper/sessionHelper';
import {
  Component,
  OnInit,
  AfterViewInit
} from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { User } from '../../core/models/user.model';
import { A3LCompanyService } from '../../core/services/a3LCompany.service';
import { A3LCompany } from '../../core/models/a3LCompany.model';
// import { Usuario } from '../../core/models/usuario.model';
// import { Empresa } from '../../core/models/empresa.model';

declare const $: any;
const misc: any = {
  navbar_menu_visible: 0,
  active_collapse: true,
  disabled_collapse_init: 0,
  sidebar_mini_active: true
};

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  providers: [AuthService, A3LCompanyService],
  // providers: [AuthService, EmpresaService, UsuarioService],
})
export class SidebarComponent implements OnInit, AfterViewInit {
  public menuItems: MenuItem[];

  usuario: User;
  empresa: string;
  sidebarMiniActive = true;


  constructor(
    private _session: SessionHelper,
    private _authService: AuthService,
    // private _usuarioService: UsuarioService,
     private _empresaService: A3LCompanyService
  ) {
  }

  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  ngOnInit() {
    this.cargarUsuario();
    this.cargarEmpresa();
  }

  cargarUsuario() {
    this.usuario = this._session.User;
    this.menuItems = MenuItems;
  }

  cargarEmpresa() {
    this.empresa = this._session.CompanyName;
    // this._empresaService
    //   .getModel(this._session.CompanyCode)
    //   .subscribe(res => (this.empresa = res));
  }

  ngAfterViewInit() {}

  minimizeSidebar() {
    const body = document.getElementsByTagName('body')[0];

    if (misc.sidebar_mini_active === true) {
      body.classList.remove('sidebar-mini');
      body.classList.add('sidebar-expand');
      misc.sidebar_mini_active = false;
      this.sidebarMiniActive = false;
    } else {
      this.sidebarMiniActive = true;
      setTimeout(function() {
        body.classList.remove('sidebar-expand');
        body.classList.add('sidebar-mini');
        misc.sidebar_mini_active = true;
      }, 300);
    }

    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(function() {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(function() {
      clearInterval(simulateWindowResize);
    }, 1000);
  }

  logOutClick() {
    this._authService.logout();
  }

  updatePS(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      const elemSidebar = <HTMLElement>(
        document.querySelector('.sidebar .sidebar-wrapper')
      );
      const ps = new PerfectScrollbar(elemSidebar, {
        wheelSpeed: 2,
        suppressScrollX: true,
      });
    }
  }

  isMac(): boolean {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf('MAC') >= 0 ||
      navigator.platform.toUpperCase().indexOf('IPAD') >= 0
    ) {
      bool = true;
    }
    return bool;
  }
}
